import { render, staticRenderFns } from "./note.vue?vue&type=template&id=5d364ee3&scoped=true&"
import script from "./note.vue?vue&type=script&lang=js&"
export * from "./note.vue?vue&type=script&lang=js&"
import style0 from "./note.vue?vue&type=style&index=0&id=5d364ee3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d364ee3",
  null
  
)

export default component.exports